
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-ex-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-ex-outline"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-ex-outline__circle",attrs:{"cx":"9","cy":"9","r":"6.15","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M6.54 6.54l4.92 4.92m0-4.92l-4.92 4.92"}})])
          )
        }
      }
    